declare namespace $ {

	type $mol_link_source__uri_our_app_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_source['uri'] >
	>
	type $mol_link__sub_our_app_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__uri_our_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_text__text_our_app_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_page__title_our_app_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_our_app_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_text__text_our_app_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_page__title_our_app_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_our_app_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_text__text_our_app_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_page__title_our_app_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_our_app_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $our_app extends $mol_book2_catalog {
		GitHub( ): $mol_link_source
		Telegram_icon( ): $mol_icon_telegram
		Telegram( ): $mol_link
		Show_text( ): $mol_text
		Show( ): $mol_page
		Game_text( ): $mol_text
		Games( ): $mol_page
		Dev( ): $our_app_dev
		Org( ): $our_app_org
		About_text( ): $mol_text
		About( ): $mol_page
		menu_title( ): string
		param( ): string
		menu_foot( ): readonly(any)[]
		spreads( ): ({ 
			'show': ReturnType< $our_app['Show'] >,
			'games': ReturnType< $our_app['Games'] >,
			'dev': ReturnType< $our_app['Dev'] >,
			'org': ReturnType< $our_app['Org'] >,
			'about': ReturnType< $our_app['About'] >,
		}) 
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map